import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Typography,
  Tabs,
  Input,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  message,
  Table,
  Radio,
  Popconfirm,
  Checkbox,
} from "antd";
import { number } from "prop-types";
import "./index.less";
import { platformApi } from "../../../../../../../api";
import { ENDPOINT } from "../../../../../../../constants";
const { TabPane } = Tabs;
const { Title, Text } = Typography;
const { Option } = Select;
const { Group } = Radio;
const Estimates = ({
  form,
  total,
  Estimate,
  data1,
  totalComplaints,
  setTotalComplaints,
  prevComplaint,
  setPreviousComplaint,
  pdf,
  status,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const isEdit = urlParams.get('edit') === 'true';

  const handleDownloadPDF = (data, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // PDF is always generated fresh on-demand by the backend endpoint.
    window.open(`${ENDPOINT}api/estimate/generatePDF/${data.id}`, "_blank");
  };

  const partItemData = {
    partNumber: {},
    quantity: "",
    unitRate: "",
    rate: "",
    remove: "",
    code: "",
  };
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const [totalEstimate, setTotalEstimate] = useState(0);
  const [gstTotal,setGstTotal] = useState(0);
  const [isAccidental,setIsAccidental] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [estId, setEstId] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [charges, setCharges] = useState({
    partCharge: 0,
    labourCharge: 0,
    consumableCharge: 0
  });
    // var dataSource = [prevComplaint, totalComplaints]
  // useEffect(() => {
  //     let data = dataSource[0]
  //     let tot = 0
  //     for (let item of data) {
  //         if (item.amount) {
  //             tot += parseInt(item.amount)
  //         }
  //     }
  //     setTotalEstimate(tot)
  // }, [])

  // Update total whenever selectedItems changes
  useEffect(() => {
    if (Estimate) {
      // Calculate total from selected items
      const selectedItemsData = dataSource.filter(item => selectedItems.includes(item.id));
      
      // Part charge - items with partNumber (without GST)
      const partCharge = selectedItemsData
        .filter(item => item.partNumber && !item.jobCode)
        .reduce((sum, item) => sum + (Number(item.rate) || 0), 0);
      
      // Labour charge - items with jobCode and consumable: false (with GST)
      const labourItems = selectedItemsData.filter(item => item.jobCode && !item.jobCode.consumable);
      const labourCharge = labourItems.reduce((sum, item) => {
        const baseAmount = Number(item.rate) || 0;
        const gstAmount = Number(item.igstAmount) || 0;
        return sum + baseAmount + gstAmount;
      }, 0);
      
      // Consumable charge - items with jobCode and consumable: true (with GST)
      const consumableItems = selectedItemsData.filter(item => item.jobCode && item.jobCode.consumable);
      const consumableCharge = consumableItems.reduce((sum, item) => {
        const baseAmount = Number(item.rate) || 0;
        const gstAmount = Number(item.igstAmount) || 0;
        return sum + baseAmount + gstAmount;
      }, 0);

      // Calculate GST amounts
      const cgstVal = selectedItemsData.reduce((sum, item) => sum + (Number(item.cgstAmount) || 0), 0);
      const sgstVal = selectedItemsData.reduce((sum, item) => sum + (Number(item.sgstAmount) || 0), 0);
      const igstVal = selectedItemsData.reduce((sum, item) => sum + (Number(item.igstAmount) || 0), 0);

      // Update charges state (without GST for display)
      setCharges({
        partCharge: partCharge.toFixed(2),
        labourCharge: labourItems.reduce((sum, item) => sum + (Number(item.rate) || 0), 0).toFixed(2),
        consumableCharge: consumableItems.reduce((sum, item) => sum + (Number(item.rate) || 0), 0).toFixed(2),
        cgst: cgstVal.toFixed(2),
        sgst: sgstVal.toFixed(2),
        igst: igstVal.toFixed(2)
      });

      // Update form fields (without GST for display)
      setFieldsValue({
        partCharge: partCharge.toFixed(2),
        labourCharge: labourItems.reduce((sum, item) => sum + (Number(item.rate) || 0), 0).toFixed(2),
        consumableCharge: consumableItems.reduce((sum, item) => sum + (Number(item.rate) || 0), 0).toFixed(2),
        cgst: cgstVal.toFixed(2),
        sgst: sgstVal.toFixed(2),
        igst: igstVal.toFixed(2)
      });

      // Calculate final total (including GST for labour and consumable)
      const total = partCharge + labourCharge + consumableCharge;
      setTotalEstimate(total.toFixed(0));
      
      // GST total is now just the total since GST is included in labour and consumable
      setGstTotal(total.toFixed(2));
    }
  }, [selectedItems, dataSource, Estimate]);

  // Handle select all checkbox
  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      // Select all items except rejected ones
      const selectableItems = dataSource
        .filter(item => item.status !== "REJECTED")
        .map(item => item.id);
      setSelectedItems(selectableItems);
    } else {
      // Keep only approved items selected
      const approvedItems = dataSource
        .filter(item => item.status === "APPROVED")
        .map(item => item.id);
      setSelectedItems(approvedItems);
    }
  };

  // Update selectAll state when individual selections change
  useEffect(() => {
    const selectableItems = dataSource
      .filter(item => item.status !== "REJECTED")
      .map(item => item.id);
    setSelectAll(selectableItems.length > 0 && 
                 selectableItems.every(id => selectedItems.includes(id)));
  }, [selectedItems, dataSource]);

  console.log("Estimate", Estimate);

  useEffect(() => {
    if (Estimate) {
      console.log("Data", Estimate);
      setEstId(Estimate.id);
      setIsAccidental(Estimate.serviceType==="Accidental");

      const items = Array.isArray(Estimate.estimateItemInvoice) ? Estimate.estimateItemInvoice : [];
      const updateItemList = items.map(item => ({ ...item }));
      for (let i = 0; i < updateItemList.length; i++) {
        if (updateItemList[i].jobCode) {
          updateItemList[i].partNumber = { ...updateItemList[i] };
          updateItemList[i].rate =
            (updateItemList[i].quantity || 0) * (updateItemList[i].unitRate || 0);
        } else {
          updateItemList[i].partNumber = { ...(updateItemList[i].partNumber || {}) };
          updateItemList[i].rate =
            (updateItemList[i].quantity || 0) * (updateItemList[i].unitRate || 0);
          updateItemList[i].gstRate = updateItemList[i].igst;
        }
      }

      // Initialize selectedItems: select all non-rejected items (approved + pending) by default
      const initialSelected = updateItemList
        .filter(item => item.status !== "REJECTED")
        .map(item => item.id);
      setSelectedItems(initialSelected);
      
      // Show all items except rejected ones
      setDataSource(updateItemList.filter(item => item.status !== "REJECTED"));

      // Set initial charges from Estimate
      const initialCgst = updateItemList.reduce((sum, item) => sum + (Number(item.cgstAmount) || 0), 0);
      const initialSgst = updateItemList.reduce((sum, item) => sum + (Number(item.sgstAmount) || 0), 0);
      const initialIgst = updateItemList.reduce((sum, item) => sum + (Number(item.igstAmount) || 0), 0);

      setFieldsValue({
        partCharge: Estimate.partCharge ? Number(Estimate.partCharge).toFixed(2) : "0.00",
        labourCharge: Estimate.labourCharge ? Number(Estimate.labourCharge).toFixed(2) : "0.00",
        consumableCharge: Estimate.consumableCharge ? Number(Estimate.consumableCharge).toFixed(2) : "0.00",
        cgst: initialCgst.toFixed(2),
        sgst: initialSgst.toFixed(2),
        igst: initialIgst.toFixed(2)
      });
    }
  }, [Estimate]);

  const setEstimate = (type) => {
    let data = {
      type: type,
      jobOrder: data1.id,
    };

    // Process individual items for all cases
    data.estimateItems = dataSource.map((item) => ({
      id: item.id,
      status: type === "REJECTED" ? "REJECTED" : 
             selectedItems.includes(item.id) ? "APPROVED" : "PENDING",
    }));

    if (type === "APPROVED") {
      platformApi
        .put(`/api/estimate/setEst/${estId}`, data)
        .then((result) => {
          let { data } = result;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              message.success("Estimate Updated Successfully");
              window.location.reload();
            }
          }
        })
        .catch((err) => {
          console.error("Estimate Add Error: ", err);
          message.error("Couldn't update Estimate");
        });
    } else if (type === "REJECTED") {
      platformApi
        .put(`/api/estimate/setEst/${estId}`, data)
        .then((result) => {
          let { data } = result;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              message.success("Estimate Rejected Successfully");
              window.location.reload();
            }
          }
        })
        .catch((err) => {
          console.error("Estimate Add Error: ", err);
          message.error("Couldn't reject Estimate");
        });
    }
  };

  const handleCheckboxChange = (id, checked) => {
    // Don't allow unchecking approved items
    const item = dataSource.find(item => item.id === id);
    if (item && item.status === "APPROVED") {
      return;
    }
    
    if (checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    }
  };

  const renderColumns = () => {
    const columns = [
      {
        title: "Details",
        dataIndex: "partNumber",
        key: "partNumber",
        width: "20%",
        render: (record, data) => (
          <Form.Item>
            <span>
              {record.jobCode
                ? `${record.jobCode.code}${record.jobCode.description ? ` - ${record.jobCode.description}` : ""}`
                : `${record.partNumber} - ${record.partName}`}
            </span>
          </Form.Item>
        ),
      },
      isAccidental && {
        title: "Part Image",
        dataIndex: "imageUrl",
        key: "image",
        width: "12%",
        render: (record, data) =>
          record ? (
            <img
              src={record}
              alt="partImage"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
              }}
            />
          ) : (
            "-"
          ),
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: "10%",
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="quantity"
              disabled={true}
              placeholder="quantity"
              value={record && record.quantity}
            />
          </Form.Item>
        ),
      },
      {
        title: "Unit rate",
        dataIndex: "unitRate",
        key: "unitRate",
        width: "10%",
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="unitRate"
              disabled={true}
              placeholder="Unit Rate"
              value={record && record.unitRate}
            />
          </Form.Item>
        ),
      },
      {
        title: "Amount",
        dataIndex: "rate",
        key: "rate",
        width: "12%",
        render: (data, record) => (
          <Form.Item>
            <Input
              key="rate"
              disabled={true}
              placeholder="Amount"
              value={record && record.rate}
            />
          </Form.Item>
        ),
      },
      // {
      //   title: "HSN",
      //   dataIndex: "hsn",
      //   key: "hsn",
      //   width: "12%",
      //   render: (data, record) => (
      //     <Form.Item>
      //       <Input
      //         key="rate"
      //         disabled={true}
      //         placeholder="HSN"
      //         value={record && record?.hsn?.code || record?.sac?.code || ""}
      //       />
      //     </Form.Item>
      //   ),
      // },
      // {
      //   title: "GST%",
      //   dataIndex: "igst",
      //   key: "gst",
      //   width: "12%",
      //   render: (data, record) => (
      //     <Form.Item>
      //       <Input
      //         key="rate"
      //         disabled={true}
      //         placeholder="HSN"
      //         value={record && record?.igst}
      //       />
      //     </Form.Item>
      //   ),
      // },
      // {
      //   title: "GST Amount",
      //   dataIndex: "igstAmount",
      //   key: "gstamount",
      //   width: "12%",
      //   render: (data, record) => (
      //     <Form.Item>
      //       <Input
      //         key="rate"
      //         disabled={true}
      //         placeholder="HSN"
      //         value={record && record?.igstAmount}
      //       />
      //     </Form.Item>
      //   ),
      // },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "10%",
        render: (status) => (
          <span style={{ 
            color: status === "APPROVED" ? "#52c41a" : 
                   status === "PENDING" ? "#faad14" : "#ff4d4f",
            fontWeight: "bold"
          }}>
            {status}
          </span>
        ),
      },
      {
        title: "Approved At",
        key: "updatedAt",
        width: "16%",
        render: (record) => (
          <span>
            {record.status === "APPROVED" ? 
              moment(new Date(record.updatedAt)).format('DD/MM/YYYY HH:mm') : 
              "-"
            }
          </span>
        ),
      },
    ].filter(Boolean);

    // Show checkbox column for all cases when estimate is pending or has pending items
    const hasPendingItems = dataSource.some(item => item.status === "PENDING");
    if (isEdit && Estimate && (Estimate.estimateStatus === "PENDING" || hasPendingItems)) {
      columns.push({
        title: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {/* Approve */}
            <Checkbox
              checked={selectAll}
              onChange={(e) => handleSelectAll(e.target.checked)}
              // style={{ marginLeft: '8px' }}
            />
          </div>
        ),
        key: "action",
        width: "10%",
        render: (data) => (
          <Checkbox
            checked={selectedItems.includes(data.id)}
            disabled={data.status === "APPROVED"}
            onChange={(e) => handleCheckboxChange(data.id, e.target.checked)}
          />
        ),
      });
    }

    return columns;
  };

  const handleTabChange = (e) => {
    let index = parseInt(e);
    let data = dataSource[index - 1];
    let tot = 0;
    for (let item of data) {
      if (item.amount) {
        tot += parseInt(item.amount);
      }
    }
    setTotalEstimate(tot);
  };

  const taxMode = (() => {
    try {
      const branchRaw = Estimate?.branch || data1?.branch || {};
      const branchGst = (branchRaw.gst || branchRaw.gstin || "").trim();
      const branchStateCode = branchGst.substring(0, 2);

      const claimStatus = Estimate?.claimStatus;
      const isClaimYes = claimStatus === true || claimStatus === "Yes" || claimStatus === "YES" || claimStatus === "yes";

      if (!isClaimYes) {
        const cust = data1?.customer || Estimate?.Customer || Estimate?.survivor || {};
        const gstType = (cust.GSTType || cust.gstType || "").toUpperCase();
        const isRegistered = (gstType.includes("REGISTERED") || gstType.includes("COMPOSITION")) && !gstType.includes("UNREGISTERED");
        const customerGst = (cust.GSTNo || cust.gstNo || cust.gstin || "").trim();

        if (!isRegistered || !customerGst) {
          return { isIntraState: true, isInterState: false };
        } else {
          const customerStateCode = customerGst.substring(0, 2);
          if (branchStateCode && customerStateCode && branchStateCode === customerStateCode) {
            return { isIntraState: true, isInterState: false };
          } else if (branchStateCode && customerStateCode && branchStateCode !== customerStateCode) {
            return { isIntraState: false, isInterState: true };
          }
        }
      } else {
        const insurance = Estimate?.Insurance || Estimate?.insurer || {};
        const dealerType = (insurance.dealerType || insurance.GSTDealerType || insurance.gstDealerType || "").toUpperCase();
        const isRegisteredDealer = dealerType.includes("REGISTERED") && !dealerType.includes("UNREGISTERED");
        const insuranceGst = (insurance.GSTIN || insurance.gstin || insurance.gst || "").trim();

        if (!isRegisteredDealer || !insuranceGst) {
          return { isIntraState: true, isInterState: false };
        } else {
          const insuranceStateCode = insuranceGst.substring(0, 2);
          if (branchStateCode && insuranceStateCode && branchStateCode === insuranceStateCode) {
            return { isIntraState: true, isInterState: false };
          } else if (branchStateCode && insuranceStateCode && branchStateCode !== insuranceStateCode) {
            return { isIntraState: false, isInterState: true };
          }
        }
      }
    } catch (err) {
      console.error("Error determineTaxMode FE:", err);
    }

    if (Estimate && Estimate.estimateItemInvoice) {
      const hasIgst = Estimate.estimateItemInvoice.some(item => (Number(item.igstAmount) > 0 || Number(item.igst) > 0));
      if (hasIgst) {
        return { isIntraState: false, isInterState: true };
      }
    }

    return { isIntraState: true, isInterState: false };
  })();

  return (
    <div style={{ padding: "40px" }}>
      {/* <Tabs
                onChange={handleTabChange}
                defaultActiveKey="1">
                <TabPane tab="Estimate-1" key="1">
                    <Table
                        columns={columns}
                        dataSource={dataSource[0]}
                        pagination={false}
                    />
                </TabPane>
                {prevComplaint.length < totalComplaints.length ?
                    <TabPane tab="Estimate-2" key="2">
                        <Table
                            columns={columns}
                            dataSource={dataSource[1]}
                            pagination={false}
                        />
                    </TabPane>
                    : null}
            </Tabs> */}
      <Table
        className="parts-invoice-table"
        columns={renderColumns()}
        dataSource={dataSource}
        pagination={false}
        scroll={{ x: 800 }}
        tableLayout="fixed"
        style={{ marginTop: "1rem", width: "100%" }}
      />
      {Estimate && (
        <div style={{ padding: "10px" }}>
          <Row gutter={32}>
            <Col xs={24} md={10}>
              <Form.Item className="form-element" label="Part Charge">
                {getFieldDecorator("partCharge", {
                  rules: [
                    {
                      required: false,
                      message: "Enter Part Charge",
                    },
                  ],
                })(<Input placeholder="Part Charge" disabled={true} />)}
              </Form.Item>

              <Form.Item className="form-element" label="Labour Charge">
                {getFieldDecorator("labourCharge", {
                  rules: [
                    {
                      required: false,
                      message: "Enter Labour Charge",
                    },
                  ],
                })(<Input placeholder="Labour Charge" disabled={true} />)}
              </Form.Item>
              <Form.Item className="form-element" label="Consumable Charge">
                {getFieldDecorator("consumableCharge", {
                  rules: [
                    {
                      required: false,
                      message: "Enter Consumable Charge",
                    },
                  ],
                })(<Input placeholder="Consumable Charge" disabled={true} />)}
              </Form.Item>
            </Col>

            <Col xs={24} md={10}>
              {taxMode.isInterState ? (
                <Form.Item className="form-element" label="IGST">
                  {getFieldDecorator("igst", {
                    rules: [
                      {
                        required: false,
                        message: "Enter IGST",
                      },
                    ],
                  })(<Input placeholder="IGST" disabled={true} />)}
                </Form.Item>
              ) : (
                <>
                  <Form.Item className="form-element" label="CGST">
                    {getFieldDecorator("cgst", {
                      rules: [
                        {
                          required: false,
                          message: "Enter CGST",
                        },
                      ],
                    })(<Input placeholder="CGST" disabled={true} />)}
                  </Form.Item>

                  <Form.Item className="form-element" label="SGST">
                    {getFieldDecorator("sgst", {
                      rules: [
                        {
                          required: false,
                          message: "Enter SGST",
                        },
                      ],
                    })(<Input placeholder="SGST" disabled={true} />)}
                  </Form.Item>
                </>
              )}
            </Col>
          </Row>
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "1rem",
          marginRight: "80px",
        }}
      >
        <table style={{ fontSize: "18px", fontWeight: "bold" }}>
          <tr>
            <td style={{ textAlign: "right", paddingRight: "8px" }}>Total</td>
            <td>:</td>
            <td>{totalEstimate}/-</td>
          </tr>
          {/* <tr>
            <td>Total + GST</td>
            <td>:</td>
            <td>{gstTotal}/-</td>
            <td>{(Number(totalEstimate) + Number(totalEstimate) * 0.18).toFixed(0)}/-</td>
          </tr> */}
          
        </table>
      </div>
      {Estimate && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "1rem",
          }}
        >
          <Button
            type="primary"
            onClick={(event) => {
              handleDownloadPDF(Estimate, event);
            }}
          >
            Download PDF
          </Button>
          <div>
            {/* Show approve button if estimate is pending or has pending items */}
            {isEdit && (Estimate.estimateStatus === "PENDING" || 
              dataSource.some(item => item.status === "PENDING")) && (() => {
              // Determine if at least one PENDING item is selected — only those
              // actually need approving. Already-APPROVED items are pre-selected
              // but locked, so they don't count toward enabling the button.
              const hasPendingSelected = dataSource.some(
                item => item.status === "PENDING" && selectedItems.includes(item.id)
              );
              return (
                <Button
                  type="primary"
                  disabled={!hasPendingSelected}
                  onClick={() => {
                    setEstimate("APPROVED");
                  }}
                >
                  {Estimate.estimateStatus === "PENDING" ? "Approve Estimate" : "Update Approval"}
                </Button>
              );
            })()}
            {/* Show reject button if estimate is pending */}
            {/* {Estimate.estimateStatus === "PENDING" && (
              <Button
                type="primary"
                danger
                style={{ marginLeft: "20px" }}
                onClick={() => {
                  setEstimate("REJECTED");
                }}
              >
                Reject Estimate
              </Button>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};
const WrappedEstimates = Form.create()(Estimates);

export default WrappedEstimates;
// export default Estimates;
